import React, { useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import { isEnvTypePROD } from '../../service/config';
import '../TableauObs/Summary/Summary.scss';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import '../DataEstate/data-estate.scss';
import { biApplicationSummary, fetchTableauSummary, getDecodedToken, fetchBIApplicationSummary, fetchTrends, getDataEstateSector, getDataEstateKpiSector, fetchPowerBIUserTrends, fetchDEPowerBIUserAndReport, fetchDEPowerBIDataset } from '../../service/service';
import SectorFilter from 'components/Dropdown/SectorFilter';
import { formatNumberWithCommas } from '../../utils/common-util';
import { Column } from 'react-data-grid';
import PageHeader from 'components/Header/Page';
import DateFilterDropdown from 'components/Dropdown/DateFilter';
import BiProcIcon from '../../assets/biApplication.svg';
import ChartWidget from 'components/Widgets/ChartWidget';
import NumberWidget from 'components/Widgets/NumberWidget';
import WidgetCardContainer from 'components/Widgets/WidgetCardContainer';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import { sectorListDetails } from 'Context/contexts/cacheData/DataEstate/type';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import { renderTooltipIcon } from '../TableauObs/common/KpiCard';

const BIApplicationSummary = () => {
	const [searchParams] = useSearchParams();
	const hasDrillDown = searchParams.has('isDrillDowned');
	const [PowerBIReports, SetPowerBIReports] = useState('-');
	const [PowerBIDashboard, SetPowerBIDashboard] = useState('-');
	const [PowerBIDataSets, SetPowerBIDataSets] = useState('-');
	const [PowerBIUsers, SetPowerBIUsers] = useState<number | string>('-');
	const [TableauReports, SetTableauReports] = useState('-');
	const [TableauDatasets, SetTableauDatasets] = useState('-');
	const [TableauCockpitUsers, SetTableauCockpitUsers] = useState('-');
	const [TableauNonCockpitUsers, SetTableauNonCockpitUsers] = useState('-');
	const [TableauLicenses, SetTableauLicenses] = useState('-')

	const [grafanaTableauLoading, setGrafanaTableauLoading] = useState(true);
	const [grafanaTableauOptions, setGrafanaTableauOptions] = useState<any>();
	const [grafanaTableauUserLoading, setGrafanaTableauUserLoading] = useState(true);
	const [grafanaTableauUserOptions, setGrafanaTableauUserOptions] = useState<any>();
	const [grafanaPowerBiLoading, setGrafanaPowerBiLoading] = useState(true);
	const [grafanaPowerBiOptions, setGrafanaPowerBiOptions] = useState<any>();
	const [, setGrafanaPowerBiUserLoading] = useState(true);
	const [, setGrafanaPowerBiUserOptions] = useState<any>();
	const [lastUpdatedDateTableauUser, setLastUpdatedDateTableauUser] = useState('');
	const [, setLastUpdatedDatePowerBiUser] = useState('');
	const [lastUpdatedDateTableau, setLastUpdatedDateTableau] = useState('');
	const [, setLastUpdatedDatePowerBi] = useState('');
	const [lastUpdatedDatePowerBIUsage, setLastUpdatedDatePowerBIUsage] = useState('');
	const [controller] = useCacheDataController();
	const { deMetricsLastSyncDate } = controller;

	// sector filter
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [, setCheckedList] = useState<any[]>([]);
	const [, setCurrSectorFilter] = useState<any[]>([]);
	const [sector] = useState<any[]>([]);
	const [filterMonth, setFilterMonth] = useState('0M');

	const dataFetchedRef = useRef(false);

	useEffect(() => {
		const onDateChange = (event: any) => {
			const selectedDate = event?.detail?.selectedDate;
			if (selectedDate) {
				setFilterMonth(selectedDate);
				clearMetricsSummary();
				getBIApplicationSummaryDetails(sector, selectedDate);
			}
		};
		window.addEventListener('dataEstateDateChanged', onDateChange);
		return () => {
			window.removeEventListener('dataEstateDateChanged', onDateChange);
		};
	}, [sector]);

	// table
	const [, setTableName] = useState('');
	const [typeName, setTypeName] = useState('');

	interface BIREPORTS {
		sector: string;
		capacityName: string;
		region: string;
		state: string;
		sku: string;
		workspaceName: string;
		reportName: string;
	}
	interface BIDASHBOARDS {
		sector: string;
		capacityName: string;
		region: string;
		state: string;
		sku: string;
		workspaceName: string;
		dashboardName: string;
	}
	interface BIDATSETS {
		sector: string;
		capacityName: string;
		workspaceName: string;
		reportCount: string;
		dataSourceType: string;
		datasetName: string;
	}
	interface BIUSERS {
		sector: string;
		capacityName: string;
		region: string;
		state: string;
		sku: string;
		workspaceName: string;
		userName: string;
	}
	interface TABLEAUREPORTSUSERS {
		userName: string;
		userType: string;
		gpid: string;
		email: string;
		lastLogin: string;
	}
	interface TABLEAUDATASETS {
		id: number;
		extractType: string;
		extractName: string;
		contentName: string;
		projectName: string;
	}
	interface Row { }
	function getColumns(): Array<Column<Row>> {
		if (typeName === 'BIREPORTS') {
			return [
				{
					key: 'sector',
					name: 'Sector',
					minWidth: 150
				},
				{
					key: 'capacityName',
					name: 'Capacity name',
					minWidth: 170
				},
				{
					key: 'region',
					name: 'Region',
					minWidth: 170
				},
				{
					key: 'state',
					name: 'State',
					minWidth: 170
				},
				{
					key: 'sku',
					name: 'SKU',
					minWidth: 170
				},
				{
					key: 'workspaceName',
					name: 'Workspace name',
					minWidth: 170
				},
				{
					key: 'reportName',
					name: 'Report name',
					minWidth: 150
				}
			];
		} else if (typeName === 'BIDASHBOARDS') {
			return [
				{
					key: 'sector',
					name: 'Sector',
					minWidth: 150
				},
				{
					key: 'capacityName',
					name: 'Capacity name',
					minWidth: 170
				},
				{
					key: 'region',
					name: 'Region',
					minWidth: 170
				},
				{
					key: 'state',
					name: 'State',
					minWidth: 170
				},
				{
					key: 'sku',
					name: 'SKU',
					minWidth: 170
				},
				{
					key: 'workspaceName',
					name: 'Workspace name',
					minWidth: 170
				},
				{
					key: 'dashboardName',
					name: 'Dashboard name',
					minWidth: 150
				}
			];
		} else if (typeName === 'BIDATASETS') {
			return [
				{
					key: 'sector',
					name: 'Sector',
					minWidth: 150
				},
				{
					key: 'capacityName',
					name: 'Capacity name',
					minWidth: 170
				},
				{
					key: 'workspaceName',
					name: 'Workspace name',
					minWidth: 170
				},
				{
					key: 'reportCount',
					name: 'Report count',
					minWidth: 170
				},
				{
					key: 'dataSourceType',
					name: 'Data source type',
					minWidth: 170
				},
				{
					key: 'datasetName',
					name: 'Dataset name',
					minWidth: 170
				}
			];
		} else if (typeName === 'BIUSERS') {
			return [
				{
					key: 'sector',
					name: 'Sector',
					minWidth: 150
				},
				{
					key: 'capacityName',
					name: 'Capacity name',
					minWidth: 170
				},
				{
					key: 'region',
					name: 'Region',
					minWidth: 170
				},
				{
					key: 'state',
					name: 'State',
					minWidth: 170
				},
				{
					key: 'sku',
					name: 'SKU',
					minWidth: 170
				},
				{
					key: 'workspaceName',
					name: 'Workspace name',
					minWidth: 170
				},
				{
					key: 'userName',
					name: 'User name',
					minWidth: 150
				}
			];
		} else if (
			typeName === 'TABLEAUREPORTS' ||
			typeName === 'TABLEAUCOCKPITUSERS' ||
			typeName === 'TABLEAUNONCOCKPITUSERS'
		) {
			return [
				{
					key: 'userName',
					name: 'User name',
					minWidth: 150
				},
				{
					key: 'userType',
					name: 'User type',
					minWidth: 170
				},
				{
					key: 'gpid',
					name: 'GPID',
					minWidth: 170
				},
				{
					key: 'email',
					name: 'Email',
					minWidth: 170
				},
				{
					key: 'lastLogin',
					name: 'Last login',
					minWidth: 170
				}
			];
		} else if (typeName === 'TABLEAUDATASETS') {
			return [
				{
					key: 'id',
					name: 'ID',
					minWidth: 150
				},
				{
					key: 'extractType',
					name: 'Extract type',
					minWidth: 170
				},
				{
					key: 'extractName',
					name: 'Extract name',
					minWidth: 170
				},
				{
					key: 'contentName',
					name: 'Content name',
					minWidth: 170
				},
				{
					key: 'projectName',
					name: 'Project name',
					minWidth: 170
				}
			];
		} else {
			return [];
		}
	}
	const BIReportColumnNames = ['Sector', 'Capacity name', 'Region', 'State', 'SKU', 'Workspace name', 'Report name'];
	const BIDashboardColumnNames = [
		'Sector',
		'Capacity name',
		'Region',
		'State',
		'SKU',
		'Workspace name',
		'Dashboard name'
	];
	const BIDatasetsColumnNames = [
		'Sector',
		'Capacity name',
		'Workspace name',
		'Report count',
		'Data source type',
		'Dataset name'
	];
	const BIUsersColumnNames = ['Sector', 'Capacity name', 'Region', 'State', 'SKU', 'Workspace name', 'User name'];
	const TableauUsersColumnNames = ['User name', 'User type', 'GPID', 'Email', 'Last login'];
	const TableauDatasetsColumnNames = ['ID', 'Extract type', 'Extract name', 'Content name', 'Project name'];
	const [, setDynamicValue] = useState(['']);
	const [, setTableData] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [, setIsDetailVisible] = useState(false);
	const dimension = useRef('');
	const tableRef = useRef<HTMLDivElement>(null);
	const [, setLoading] = useState(false);
	const [customMonth, setCustomMonth] = useState('');
	const [grafanaPowerBIUsageOptions, setGrafanaPowerBIUsageOption] = useState<any>();
	const [grafanaPowerBiUsageLoading, setGrafanaPowerBIUsageLoading] = useState(true);
	const [sectorName, setSectorName] = useState('all');

	const [allSectorOptionsList, setAllSectorOptionsList] = useState<sectorListDetails | null>(null);
	const [sectorTagList, setSectorTagList] = useState<any>({ tableauReport: true, tableauDatasets: true, tableauCockpit: true, tableauGlobal: true, powerBiReport: true, powerBiDataset: true, powerBiWorkspace: true });

	async function summaryListingFunc(pageNumber: any, size: any, sortingInfo: any) {
		setLoading(true);
		let month = customMonth ? customMonth : filterMonth;
		const res = await biApplicationSummary('powerbi', dimension.current, sector, month);
		if (res.success) {
			setLoading(false);
			setTableData(res.data.summary);
			setPaginationData(res.data.page);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
		}
		setTimeout(() => {
			if (tableRef.current) {
				tableRef.current.scrollIntoView({ behavior: 'smooth' });
			}
		}, 1000);
	}

	const handleMetricsOnclick = (value: any) => {
		setDynamicValue(['']);
		setTableData([]);
		setIsDetailVisible(true);
		setTypeName(value);
		if (value === 'BIREPORTS') {
			setDynamicValue(BIReportColumnNames);
			type Row = keyof BIREPORTS;
			setTableName('PowerBI Reports');
			dimension.current = 'powerbi-reports';
		} else if (value === 'BIDASHBOARDS') {
			setDynamicValue(BIDashboardColumnNames);
			type Row = keyof BIDASHBOARDS;
			setTableName('PowerBI Dashboards');
			dimension.current = 'powerbi-dashboards';
		} else if (value === 'BIDATASETS') {
			setDynamicValue(BIDatasetsColumnNames);
			type Row = keyof BIDATSETS;
			setTableName('PowerBI Datasets');
			dimension.current = 'powerbi-datasets';
		} else if (value === 'BIUSERS') {
			setDynamicValue(BIUsersColumnNames);
			type Row = keyof BIUSERS;
			setTableName('PowerBI Users');
			dimension.current = 'powerbi-users';
		} else if (value === 'TABLEAUREPORTS' || value === 'TABLEAUCOCKPITUSERS' || value === 'TABLEAUNONCOCKPITUSERS') {
			setDynamicValue(TableauUsersColumnNames);
			type Row = keyof TABLEAUREPORTSUSERS;
			if (value === 'TABLEAUREPORTS') {
				setTableName('Tableau Reports');
				dimension.current = 'tableau-reports';
			} else if (value === 'TABLEAUCOCKPITUSERS') {
				setTableName('Tableau Cockpit Users');
				dimension.current = 'tableau-cockpit-users';
			} else {
				setTableName('Tableau Non-Cockpit Users');
				dimension.current = 'tableau-noncockpit-users';
			}
		} else if (value === 'TABLEAUDATASETS') {
			setDynamicValue(TableauDatasetsColumnNames);
			type Row = keyof TABLEAUDATASETS;
			setTableName('Tableau Datasets');
			dimension.current = 'tableau-datasets';
		}
		summaryListingFunc(page, pageSize, sortingInfo);
	};

	const clearMetricsSummary = () => {
		setTableData([]);
		setIsDetailVisible(false);
	};

	const handleDateFilter = (selectedDate: string) => {
		clearMetricsSummary();
		getBIApplicationSummaryDetails(sector, selectedDate);
	};

	async function fetchSectorOptionsData() {
		let sectorKpi = [];
		sectorKpi.push("tableauUser");
		const sectorRes = await getDataEstateKpiSector(sectorKpi);
		if (sectorRes.success) {
			if (sectorRes.data) {
				setAllSectorOptionsList(sectorRes.data);
			}
		}
		const sectorKpiRes = await getDataEstateSector();
		if (sectorKpiRes.success) {
			if (sectorKpiRes.data) {
				const sectorValues = sectorKpiRes.data.map((item: { sector: any; }) => item.sector);
				const uniqueSectors = Array.from(new Set(sectorValues));
				const sectorNameList: string[] = uniqueSectors.map(sector =>
					(sector === "" || sector === null || sector === undefined) ? "Blank" : String(sector)
				);
				const sortedSectors = [...sectorNameList].sort((a: string, b: string) => a.localeCompare(b));
				setSectorOptionsList(sortedSectors);
			}
		}
	}

	async function getBIApplicationSummaryDetails(sectors: any, month: any) {
		let sector = sectors.length == sectorOptionsList.length ? [] : sectors;
		SetPowerBIReports('-');
		SetPowerBIDashboard('-');
		SetPowerBIDataSets('-');
		SetPowerBIUsers('-');
		SetTableauReports('-');
		SetTableauDatasets('-');
		SetTableauCockpitUsers('-');
		SetTableauLicenses('-');
		SetTableauNonCockpitUsers('-');
		setGrafanaTableauLoading(true);
		setGrafanaTableauUserLoading(true);
		setGrafanaPowerBiLoading(true);
		setGrafanaPowerBiUserLoading(true);
		const todaysDate = moment().utc().format('YYYY-MM-DD');
		fetchTrends('datasetgrowth', 'tableau', sector, month)
			.then((res) => {
				setGrafanaTableauOptions(res.data.data);
				setLastUpdatedDateTableau(res?.data.lastUpdatedDate ? res.data.lastUpdatedDate : todaysDate);
				setGrafanaTableauLoading(false);
			})
			.catch((error) => {
				console.error(error);
			});
		fetchTrends('tabeauusergrowth', 'tableau', sector, month)
			.then((res) => {
				setGrafanaTableauUserOptions(res.data.data)
				setLastUpdatedDateTableauUser(res.data.lastUpdatedDate);
				setGrafanaTableauUserLoading(false);
			})
			.catch((error) => {
				console.error(error);
			});
		fetchTrends('powerBiDataset', 'powerbi', sector, month).then((res) => {
			if (res.data) {
				setGrafanaPowerBiOptions(res.data.data);
				setLastUpdatedDatePowerBi(res.data.lastUpdatedDate);
				setGrafanaPowerBiLoading(false);
			}
		})
			.catch((error) => {
				console.error(error);
			});
		fetchTrends('usergrowth', 'powerbi', sector, month).then((res) => {
			if (res.data) {
				console.log(res.data)
				setGrafanaPowerBiUserOptions(res.data.data);
				setLastUpdatedDatePowerBiUser(res?.data.lastUpdatedDate ? res.data.lastUpdatedDate : todaysDate);
				setGrafanaPowerBiUserLoading(false);
			}
		})
			.catch((error) => {
				console.error(error);
			});
		fetchDEPowerBIUserAndReport(sector, 'powerBIReportCount', 0)
			.then((res) => {
				const values = Object.values(res?.data || []);
				const count = Number(values.at(-1)) || 0;
				SetPowerBIReports((count / 1000).toFixed(2).toString());
			})
			.catch((error) => {
				console.error(error);
			});
		fetchDEPowerBIUserAndReport(sector, 'userCount', 0)
			.then((res) => {
				const values = Object.values(res?.data || []);
				const count = Number(values.at(-1)) || 0;
				SetPowerBIUsers((count / 1000).toFixed(2));
			})
			.catch((error) => {
				console.error(error);
			});
		fetchBIApplicationSummary('powerbi-dashboards', sector, month)
			.then((res) => {
				let count = res?.data?.result[0]?.PowerBIDashboardsCount;
				SetPowerBIDashboard((count / 1000).toFixed(2).toString());
			})
			.catch((error) => {
				console.error(error);
			});
		fetchDEPowerBIDataset(sector)
			.then((res) => {
				let count = res?.data?.count;
				SetPowerBIDataSets((count / 1000).toFixed(2).toString());
			})
			.catch((error) => {
				console.error(error);
			});

		fetchPowerBIUserTrends(sector)
			.then((res) => {
				setGrafanaPowerBIUsageOption(res?.data.data);
				setLastUpdatedDatePowerBIUsage(res.data.lastUpdatedDate);
				setGrafanaPowerBIUsageLoading(false);
			})
			.catch((error: any) => {
				console.error(error);
			});

		fetchTableauSummary(sector, month).then(res => {
			let tableauReportsCount = res?.data?.result?.tableauReports
			SetTableauReports((tableauReportsCount / 1000).toFixed(2).toString());
			let tableauDatasetsCount = res?.data?.result?.tableauDatasets;
			SetTableauDatasets((tableauDatasetsCount / 1000).toFixed(2).toString());
			let tableauCockpitUserCount = res?.data?.result?.tableauCockpitUserCount;
			SetTableauCockpitUsers((tableauCockpitUserCount / 1000).toFixed(2).toString());
			let tableauNonCockpitUserCount = res?.data?.result?.tableauNonCockpitUserCount;
			SetTableauNonCockpitUsers((tableauNonCockpitUserCount / 1000).toFixed(2).toString());
			let tableauLicenseCount = res?.data?.result?.tableauLicenseCount
			SetTableauLicenses((tableauLicenseCount / 1000).toFixed(2).toString());
		})
			.catch((error) => {
				console.error(error);
			});
	}

	useEffect(() => {
		if (hasDrillDown) {
			const selectedSector = localStorage.getItem('selectedSector');
			if (selectedSector) {
				const selectedSec = JSON.parse(selectedSector).length ? JSON.parse(selectedSector) : '';
				setCheckedList(selectedSec);
				setCurrSectorFilter(selectedSec);
			}
		} else {
			localStorage.removeItem('selectedSector');
		}

		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		if (userSector === 'all') fetchSectorOptionsData();
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/dataestate/biApplicationSummary') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
				document.body.classList.add('custom-class');
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list');
				activeId.classList.remove('root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas');
				document.body.classList.add('datefilter-align-sector');
				document.body.classList.add('sector-label');
			}
		} else {
			if (activeId) {
				document.body.classList.remove('jobs-list-datas');
				activeId.classList.add('root');
				document.body.classList.add('dashboard-panel-dataestate');
				document.body.classList.add('datefilter-align-sector');
			}
		}
		getBIApplicationSummaryDetails('all', filterMonth);
	}, []);
	const handleSectorChange = (value: string) => {
		setLoading(true);
		setSectorName(value);
		getBIApplicationSummaryDetails(value, '');
		sectorTagUpdatefun(value);

	};

	const sectorTagUpdatefun = (sector: string) => {
		if (sector != 'all') {
			if (sector == 'Blank')
				sector = '';

			const isInAzure = allSectorOptionsList?.tableauReport.some(item => item.sector === sector);
			const isInDatasets = allSectorOptionsList?.tableauDatasets.some(item => item.sector === sector);
			const isInCockpit = allSectorOptionsList?.tableauCockpit.some(item => item.sector === sector);
			const isInGlobal = allSectorOptionsList?.tableauGlobal.some(item => item.sector === sector);
			const filteredData = {
				tableauReport: isInAzure || false,
				tableauDatasets: isInDatasets || false,
				tableauCockpit: isInCockpit || false,
				tableauGlobal: isInGlobal || false
			};
			setSectorTagList(filteredData);
			getBIApplicationSummaryDetails(filteredData.tableauReport ? sector : 'all', "");
		} else {
			const filteredData = {
				azure: true,
				databricks: true,
				teradata: true
			};
			getBIApplicationSummaryDetails(filteredData, "");

		}
	}

	const getSectorLabel = (tagKey: string) => (sectorTagList?.[tagKey] && sectorName !== 'all' ? sectorName : '');

	return (
		<PageWrapper>
			<PageHeader title="BI Application Summary" icon={BiProcIcon} lastSync={deMetricsLastSyncDate}>
				{/* <DateFilterDropdown
				customMonth={customMonth}
				filterMonth={filterMonth}
				setCustomMonth={setCustomMonth}
				setFilterMonth={setFilterMonth}
				handleChange={handleDateFilter}
			/> */}
				{/* <SectorFilter
					sectorName={sectorName}
					setSectorName={setSectorName}
					sectorOptionsList={sectorOptionsList}
					handleChange={handleSectorChange}
				/> */}
			</PageHeader >
			<Grid container spacing={1} p={{ md: 2 }} mt={2}>
				<Grid item container xs={12} md={6}>
					<WidgetCardContainer bgColor='#E4EDFF' title="Power BI" titleSx={{ fontSize: "24px" }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={6} id="pbi-reports">
								<NumberWidget
									title={<HighlightedText text="Reports" />}
									tooltipLabel={''}
									hasTooltip={false}
									// tooltipLabel={`Total Power BI reports in PROD${sectorName !== 'all' ? ` (${sectorName})` : ''}`}
									// renderTooltip={(label) => renderTooltipIcon(label, 'light')}
									number={
										PowerBIReports && PowerBIReports.toString() !== '-' ? formatNumberWithCommas(PowerBIReports) : '-'
									}
									units={PowerBIReports && PowerBIReports.toString() !== '-' ? 'k' : ''}
									isLoading={PowerBIReports ? PowerBIReports.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('BIREPORTS')}
									sectorLabel={getSectorLabel('powerBiReport')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} md={6} id="pbi-datasets">
								<NumberWidget
									title={<HighlightedText text="Datasets" />}
									tooltipLabel={''}
									hasTooltip={false}
									//tooltipLabel={`Total Power BI datasets in PROD${sectorName !== 'all' ? ` (${sectorName})` : ''}`}
									//renderTooltip={(label) => renderTooltipIcon(label, 'light')}
									number={
										PowerBIDataSets && PowerBIDataSets.toString() !== '-'
											? formatNumberWithCommas(PowerBIDataSets)
											: '-'
									}
									units={PowerBIDataSets && PowerBIDataSets.toString() !== '-' ? 'k' : ''}
									isLoading={PowerBIDataSets ? PowerBIDataSets.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('BIDATASETS')}
									sectorLabel={getSectorLabel('powerBiDataset')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} md={6} id="pbi-workspaces">
								<NumberWidget
									title={<HighlightedText text="Workspaces" />}
									tooltipLabel={''}
									hasTooltip={false}
									//tooltipLabel={`Total Power BI workspaces in PROD${sectorName !== 'all' ? ` (${sectorName})` : ''}`}
									//renderTooltip={(label) => renderTooltipIcon(label, 'light')}
									number={PowerBIDashboard && PowerBIDashboard.toString() !== '-' ? PowerBIDashboard : '-'}
									units={PowerBIDashboard && PowerBIDashboard.toString() !== '-' ? 'k' : ''}
									isLoading={PowerBIDashboard ? PowerBIDashboard.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('BIDASHBOARDS')}
									sectorLabel={getSectorLabel('powerBiWorkspace')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} md={6} id="pbi-users">
								<NumberWidget
									title={<HighlightedText text="Users" />}
									tooltipLabel={''}
									hasTooltip={false}
									//tooltipLabel={`Total Power BI users in PROD${sectorName !== 'all' ? ` (${sectorName})` : ''}`}
									//renderTooltip={(label) => renderTooltipIcon(label, 'light')}
									number={PowerBIUsers && PowerBIUsers.toString() !== '-' ? PowerBIUsers : '-'}
									units={PowerBIUsers && PowerBIUsers.toString() !== '-' ? 'k' : ''}
									isLoading={PowerBIUsers ? PowerBIUsers.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('BIUSERS')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} id="pbi-datasets-trend">
								<ChartWidget
									title={<HighlightedText text="Datasets Trend" />}
									//tooltipLabel={`Power BI datasets trend over time${lastUpdatedDatePowerBIUsage ? ` (Last Sync: ${lastUpdatedDatePowerBIUsage})` : deMetricsLastSyncDate ? ` (Last Sync: ${deMetricsLastSyncDate})` : ''}`}
									data={grafanaPowerBiOptions}
									isLoading={grafanaPowerBiLoading}
									titleColor="#000000"
									chartBgColor="#FBFDFF"
									lineColor="#003771"
									isDataEstateQuery={true} />
								{/* <UnderDevelopmentWidget title="Datasets Trend" /> */}
							</Grid>
							<Grid item xs={12} id="pbi-usage-trend">
								<ChartWidget
									title={<HighlightedText text="User Trend" />}
									//tooltipLabel={`Power BI user trend over time${lastUpdatedDatePowerBIUsage ? ` (Last Sync: ${lastUpdatedDatePowerBIUsage})` : deMetricsLastSyncDate ? ` (Last Sync: ${deMetricsLastSyncDate})` : ''}`}
									data={grafanaPowerBIUsageOptions}
									isLoading={grafanaPowerBiUsageLoading}
									lastUpdatedDate={lastUpdatedDatePowerBIUsage}
									titleColor="#000000"
									chartBgColor="#FBFDFF"
									lineColor="#003771"
									isDataEstateQuery={true}
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>
				<Grid item container xs={12} md={6}>
					<WidgetCardContainer bgColor='#E4EDFF' title="Tableau" titleSx={{ fontSize: "24px" }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={4} id="tbl-reports">
								<NumberWidget
									title={<HighlightedText text="Reports" />}
									tooltipLabel={TableauReports !== '-' && Number(TableauReports) === 0 ? 'Data Unavailable' : ''}
									hasTooltip={TableauReports !== '-' && Number(TableauReports) === 0}
									number={
										TableauReports && TableauReports.toString() !== '-' ? formatNumberWithCommas(TableauReports) : '-'
									}
									units={TableauReports && TableauReports.toString() !== '-' ? 'k' : ''}
									isLoading={TableauReports ? TableauReports.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('TABLEAUREPORTS')}
									sectorLabel={getSectorLabel('tableauReport')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} md={4} id="tbl-datasets">
								<NumberWidget
									title={<HighlightedText text="Datasets" />}
									tooltipLabel={TableauDatasets !== '-' && Number(TableauDatasets) === 0 ? 'Data Unavailable' : ''}
									hasTooltip={TableauDatasets !== '-' && Number(TableauDatasets) === 0}
									number={
										TableauDatasets && TableauDatasets.toString() !== '-'
											? formatNumberWithCommas(TableauDatasets)
											: '-'
									}
									units={TableauDatasets && TableauDatasets.toString() !== '-' ? 'k' : ''}
									isLoading={TableauDatasets ? TableauDatasets.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('TABLEAUDATASETS')}
									sectorLabel={getSectorLabel('tableauDatasets')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} md={4} id="tbl-licenses">
								<NumberWidget
									title={<HighlightedText text="Licenses" />}
									tooltipLabel={TableauLicenses !== '-' && Number(TableauLicenses) === 0 ? 'Data Unavailable' : ''}
									hasTooltip={TableauLicenses !== '-' && Number(TableauLicenses) === 0}
									number={
										TableauLicenses && TableauLicenses.toString() !== '-'
											? formatNumberWithCommas(TableauLicenses)
											: '-'
									}
									units={TableauLicenses && TableauLicenses.toString() !== '-' ? 'k' : ''}
									isLoading={TableauLicenses ? TableauLicenses.toString() === '-' : false}
									handleEvent={undefined}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} md={6} id="tbl-cockpit-users">
								<NumberWidget
									title={<HighlightedText text="Cockpit Users" />}
									tooltipLabel={TableauCockpitUsers !== '-' && Number(TableauCockpitUsers) === 0 ? 'Data Unavailable' : ''}
									hasTooltip={TableauCockpitUsers !== '-' && Number(TableauCockpitUsers) === 0}
									number={
										TableauCockpitUsers && TableauCockpitUsers.toString() !== '-'
											? formatNumberWithCommas(TableauCockpitUsers)
											: '-'
									}
									units={TableauCockpitUsers && TableauCockpitUsers.toString() !== '-' ? 'k' : ''}
									isLoading={TableauCockpitUsers ? TableauCockpitUsers.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('TABLEAUCOCKPITUSERS')}
									sectorLabel={getSectorLabel('tableauCockpit')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}

								/>
							</Grid>
							<Grid item xs={12} md={6} id="tbl-global-users">
								<NumberWidget
									title={<HighlightedText text="Global Users" />}
									tooltipLabel={TableauNonCockpitUsers !== '-' && Number(TableauNonCockpitUsers) === 0 ? 'Data Unavailable' : ''}
									hasTooltip={TableauNonCockpitUsers !== '-' && Number(TableauNonCockpitUsers) === 0}
									number={
										TableauNonCockpitUsers && TableauNonCockpitUsers.toString() !== '-'
											? formatNumberWithCommas(TableauNonCockpitUsers)
											: '-'
									}
									units={TableauNonCockpitUsers && TableauNonCockpitUsers.toString() !== '-' ? 'k' : ''}
									isLoading={TableauNonCockpitUsers ? TableauNonCockpitUsers.toString() === '-' : false}
									handleEvent={isEnvTypePROD ? undefined : () => handleMetricsOnclick('TABLEAUNONCOCKPITUSERS')}
									sectorLabel={getSectorLabel('tableauGlobal')}
									bgColor='#ffffff'
									color='#000000'
									valueFontWeight={300}
									sameDecimalSize={true}
								/>
							</Grid>
							<Grid item xs={12} id="tbl-datasets-trend">
								<ChartWidget
									title={<HighlightedText text="Datasets Trend" />}
									//tooltipLabel={`Tableau datasets trend over time${lastUpdatedDateTableau ? ` (Last Sync: ${lastUpdatedDateTableau})` : deMetricsLastSyncDate ? ` (Last Sync: ${deMetricsLastSyncDate})` : ''}`}
									data={grafanaTableauOptions}
									isLoading={grafanaTableauLoading}
									lastUpdatedDate={lastUpdatedDateTableau}
									titleColor="#000000"
									chartBgColor="#FBFDFF"
									lineColor="#003771"
									isDataEstateQuery={true}
								/>
							</Grid>
							<Grid item xs={12} id="tbl-usage-trend">
								<ChartWidget
									title={<HighlightedText text="Users Trend" />}
									//tooltipLabel={`Tableau users trend over time${lastUpdatedDateTableauUser ? ` (Last Sync: ${lastUpdatedDateTableauUser})` : deMetricsLastSyncDate ? ` (Last Sync: ${deMetricsLastSyncDate})` : ''}`}
									data={grafanaTableauUserOptions}
									isLoading={grafanaTableauUserLoading}
									lastUpdatedDate={lastUpdatedDateTableauUser}
									titleColor="#000000"
									chartBgColor="#FBFDFF"
									lineColor="#003771"
									isDataEstateQuery={true}
								/>
							</Grid>
						</Grid>
					</WidgetCardContainer>
				</Grid>
			</Grid>
		</PageWrapper >
	);
};

export default BIApplicationSummary;
